import type { TextInputProps } from 'react-native'

/**
 * Keyboards with no return key. iOS draws a floating button of its own when
 * one of these is asked for a return key, and it lands over the screen's
 * bottom-right — where the advance control already is.
 */
export const PADS_WITHOUT_RETURN_KEY = new Set<TextInputProps['keyboardType']>([
  'number-pad',
  'numeric',
  'decimal-pad',
  'phone-pad',
])
